/* BKP ontwerp-wizard. Leest data uit script[data-bkp-wizard-data]. */
(function () {
  var root = document.querySelector('[data-bkp-wizard]');
  if (!root) return;
  var DATA;
  try { DATA = JSON.parse(document.querySelector('[data-bkp-wizard-data]').textContent); }
  catch (e) { return; }

  // Een metafieldkleur is presentatiedata (Nederlandse naam, hex en foto's),
  // terwijl Shopify-varianten uit imports vaak Engelse waarden gebruiken.
  // Koppel beide lagen expliciet zodat "Zwart" bijvoorbeeld variant "Black"
  // bestelt. Ongekoppelde variantkleuren blijven altijd als veilige fallback
  // beschikbaar: een fout metafield mag nooit alle maten laten verdwijnen.
  function normaliseerKleurNaam(waarde) {
    return String(waarde || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  var KLEUR_ALIASES = {
    black: 'zwart', zwart: 'zwart',
    white: 'wit', wit: 'wit',
    orange: 'oranje', oranje: 'oranje',
    purple: 'paars', paars: 'paars',
    red: 'rood', rood: 'rood',
    yellow: 'geel', geel: 'geel',
    royal: 'royalblue', royalblue: 'royalblue',
    solidgrey: 'molgrijs', solidgray: 'molgrijs', molegrey: 'molgrijs', molegray: 'molgrijs', molgrijs: 'molgrijs',
    turqouise: 'turquoise', turquoise: 'turquoise'
  };
  function canoniekeKleurNaam(waarde) {
    var sleutel = normaliseerKleurNaam(waarde);
    return KLEUR_ALIASES[sleutel] || sleutel;
  }
  function uniekeVariantKleuren() {
    var gezien = [];
    (DATA.variants || []).forEach(function (variant) {
      if (variant.kleur != null && gezien.indexOf(variant.kleur) === -1) gezien.push(variant.kleur);
    });
    return gezien;
  }
  function koppelMetaKleuren(metaKleuren, variantKleuren) {
    var gekoppeld = [], gebruikt = {};
    var gelijkeReeks = metaKleuren.length === variantKleuren.length;
    metaKleuren.forEach(function (kleur, index) {
      var naam = kleur && kleur.naam;
      var match = variantKleuren.filter(function (variantNaam) {
        return !gebruikt[variantNaam] && normaliseerKleurNaam(variantNaam) === normaliseerKleurNaam(naam);
      })[0];
      if (!match) {
        match = variantKleuren.filter(function (variantNaam) {
          return !gebruikt[variantNaam] && canoniekeKleurNaam(variantNaam) === canoniekeKleurNaam(naam);
        })[0];
      }
      // Bij een volledige, gelijk geordende metafieldreeks is de positie een
      // betrouwbare laatste fallback voor leveranciersnamen als Stone/Sport Grijs.
      if (!match && gelijkeReeks && !gebruikt[variantKleuren[index]]) match = variantKleuren[index];
      if (!match) return;
      gebruikt[match] = true;
      gekoppeld.push(Object.assign({}, kleur, { variantNaam: match }));
    });
    variantKleuren.forEach(function (variantNaam) {
      if (gebruikt[variantNaam]) return;
      gekoppeld.push({ naam: variantNaam, variantNaam: variantNaam, hex: null, voor: null, achter: null });
    });
    return gekoppeld;
  }

  var variantKleuren = uniekeVariantKleuren();
  if ((DATA.kleuren || []).length && variantKleuren.length) {
    DATA.kleuren = koppelMetaKleuren(DATA.kleuren, variantKleuren);
  }

  var TECHS = ['Geen bedrukking'].concat(DATA.technieken || []);
  var STORAGE_KEY = 'bkp-wizard-' + root.getAttribute('data-product-id');
  var state = {
    view: 'voor',
    kleur: (DATA.kleuren[0] || { naam: '', hex: '#e6e9f2' }),
    qty: {},               // maat -> aantal
    techniek: 'Geen bedrukking',
    positions: [],          // geselecteerde positie-keys
    designs: {},            // key -> {type,text,font,color,logoUrl,logoFile,logoName,isVector,x,y,scale}
    spoed: false,
    proofApproved: false,
    designId: 'bkp-' + Date.now().toString(36)
  };

  // kleur-modi: metaobject-kleuren (dots+hex), simpele variant-kleuren (tekst-pills) of geen kleurkeuze
  var heeftMetaKleuren = (DATA.kleuren || []).length > 0;
  var simpeleKleuren = (!heeftMetaKleuren && (DATA.kleurenSimpel || []).length) ? DATA.kleurenSimpel : [];
  var kleurDimensie = heeftMetaKleuren || simpeleKleuren.length > 0;
  // Alleen een echte Shopify-variantoptie mag de varianten op kleur filteren.
  // Metafieldkleuren zonder variantas delen gewoon dezelfde beschikbare maten.
  var variantKleurDimensie = variantKleuren.length > 0;
  if (!heeftMetaKleuren) {
    state.kleur = simpeleKleuren.length ? { naam: simpeleKleuren[0], hex: null } : { naam: null, hex: null };
  }

  try {
    var saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && saved.kleur && saved.designId) {
      state = Object.assign(state, saved);
      if (heeftMetaKleuren) {
        state.kleur = (DATA.kleuren || []).filter(function (k) { return k.naam === saved.kleur.naam; })[0] || DATA.kleuren[0] || state.kleur;
      } else if (simpeleKleuren.length) {
        state.kleur = { naam: simpeleKleuren.indexOf(saved.kleur.naam) !== -1 ? saved.kleur.naam : simpeleKleuren[0], hex: null };
      } else {
        state.kleur = { naam: null, hex: null };
      }
      Object.keys(state.designs || {}).forEach(function (key) {
        var design = state.designs[key];
        design.logoUrl = null;
        design.logoFile = null;
        // Browsers mogen een lokaal bestand na herladen niet herstellen. Wis de
        // naam daarom ook, zodat de klant het bestand verplicht opnieuw kiest.
        if (design.type === 'logo') {
          design.logoName = '';
          design.isVector = false;
        }
      });
      // Een herstelde configuratie moet altijd opnieuw visueel worden bevestigd.
      state.proofApproved = false;
    }
  } catch (e) { /* begin met een schone configuratie */ }
  if (!DATA.bedrukkingMogelijk) { state.techniek = 'Geen bedrukking'; state.positions = []; }

  // ----- helpers -----
  var $ = function (sel) { return root.querySelector(sel); };
  var euro = function (cents) { return '€ ' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  function serializableState() {
    var clean = JSON.parse(JSON.stringify(state));
    Object.keys(clean.designs || {}).forEach(function (key) {
      delete clean.designs[key].logoUrl;
      delete clean.designs[key].logoFile;
    });
    delete clean.galleryUrl; // galerij-weergave is tijdelijk, niet herstellen
    return clean;
  }
  function saveState() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(serializableState())); } catch (e) { /* opslag is optioneel */ }
  }
  function invalidateApproval() {
    state.proofApproved = false;
    var approval = root.querySelector('[data-proof-approval]');
    if (approval) approval.checked = false;
  }
  function variantKleurVoor(kleur) {
    var gekoppeld = (DATA.kleuren || []).filter(function (item) { return item.naam === kleur; })[0];
    return gekoppeld && gekoppeld.variantNaam ? gekoppeld.variantNaam : kleur;
  }
  function sizesForKleur(kleur) {
    var seen = [], out = [];
    var variantKleur = variantKleurVoor(kleur);
    DATA.variants.forEach(function (v) {
      if (variantKleurDimensie && v.kleur !== variantKleur) return;
      if (seen.indexOf(v.maat) === -1) { seen.push(v.maat); out.push(v); }
    });
    return out;
  }
  function variantId(kleur, maat) {
    var variantKleur = variantKleurVoor(kleur);
    var hit = DATA.variants.filter(function (v) { return (!variantKleurDimensie || v.kleur === variantKleur) && v.maat === maat; })[0];
    return hit ? hit.id : null;
  }
  function totalQty() { var t = 0; for (var k in state.qty) t += state.qty[k] || 0; return t; }

  // Minimale afname en offerte-drempel gelden over de HELE bestelling: mixen mag
  // (2 broeken + 3 shirts = 5). We tellen daarom mee wat er al in de winkelwagen
  // ligt. Kant-en-klare artikelen (minimum 1) vallen buiten die regel.
  var perStuk = (DATA.minAfname || 0) <= 1;
  var maxAfname = perStuk ? 0 : (DATA.offerteVanaf || 0) - 1;
  var winkelwagenQty = 0;
  // stuks in de winkelwagen met DEZELFDE offerte-drempel als dit product: alleen die
  // tellen mee voor de drempel (stickers mogen tot 499, kleding tot 50 — die mogen
  // elkaar niet blokkeren). Voor de minimale afname telt wél de hele bestelling.
  var winkelwagenQtyZelfdeDrempel = 0;
  var spoedInCart = false; // spoedlevering is EENMALIG per bestelling
  function bestelQty() { return winkelwagenQty + totalQty(); }
  /** aantal voor de offerte-drempel: eigen ontwerp + winkelwagenregels met dezelfde drempel */
  function drempelQty() { return winkelwagenQtyZelfdeDrempel + totalQty(); }
  function updateSpoedUI() {
    var wrap = $('[data-spoed-wrap]');
    if (!wrap || wrap.hidden) return;
    var cb = $('[data-spoed]');
    var al = wrap.querySelector('[data-spoed-al]');
    if (spoedInCart) {
      // al in de winkelwagen: tonen als actief maar niet nogmaals rekenen/toevoegen
      cb.checked = true; cb.disabled = true; state.spoed = false;
      if (al) al.hidden = false;
    } else {
      cb.disabled = false; cb.checked = Boolean(state.spoed);
      if (al) al.hidden = true;
    }
  }
  function laadWinkelwagen() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var t = 0, tDrempel = 0;
        var spoedId = feeId('spoed');
        spoedInCart = false;
        (cart.items || []).forEach(function (i) {
          if (spoedId && i.id === spoedId) spoedInCart = true;
          var p = i.properties || {};
          // dit ontwerp zit al in de teller van de wizard zelf
          if (p._bkp_design_id && p._bkp_design_id === state.designId) return;
          if ((parseInt(p._bkp_min, 10) || 0) <= 1) return; // los artikel of toeslag
          t += i.quantity;
          if ((parseInt(p._bkp_max, 10) || 0) === maxAfname) tDrempel += i.quantity;
        });
        winkelwagenQty = t;
        winkelwagenQtyZelfdeDrempel = tDrempel;
        updateSpoedUI();
        renderTotals();
      })
      .catch(function () { /* zonder winkelwagen rekenen we alleen met dit ontwerp */ });
  }
  function activeTier() {
    // hoogste behaalde 'min' wint, onafhankelijk van de volgorde in het metafield
    var q = totalQty(), s = DATA.staffels || [], hit = null;
    s.forEach(function (t) { if (q >= t.min && (!hit || t.min >= hit.min)) hit = t; });
    return hit;
  }
  function unitCents() {
    var t = activeTier(); var korting = t ? (t.korting_pct || 0) : 0;
    // Zelfde afronding als Shopify: het kortingsbedrag per stuk wordt naar beneden
    // afgerond. Zo is de getoonde stukprijs exact wat de checkout rekent.
    return DATA.base - Math.floor(DATA.base * korting / 100);
  }

  // ----- meerprijs bedrukking (per stuk, per gekozen positie) -----
  // Klant 27-07: klein en groot hebben elk een vaste meerprijs per stuk; hierover
  // wordt GEEN staffelkorting gegeven. De cart-transform-functie rekent hetzelfde.
  function posInfo(key) {
    return (DATA.posities || []).filter(function (p) { return p.key === key; })[0] || null;
  }
  // prijs van de positie zelf (los van de gekozen techniek, zodat het label bij de
  // keuze altijd klopt); of hij meetelt bepalen drukPerStuk/drukAantallen
  function drukPrijsVoor(key) {
    var p = posInfo(key);
    if (!p) return 0;
    var klasse = (p.prijsklasse || 'klein').toLowerCase();
    if (klasse === 'geen') return 0;
    return (DATA.drukPrijzen || {})[klasse] || 0;
  }
  /** aantal gekozen posities per prijsklasse, bv. {klein: 2, groot: 1} */
  function drukAantallen() {
    var uit = { klein: 0, groot: 0 };
    // product waar bedrukking niet kan: nooit bedrukking rekenen, wat de DOM ook zegt
    if (!DATA.bedrukkingMogelijk) return uit;
    if (state.techniek === 'Geen bedrukking') return uit;
    // niet actief (geen prijzen doorgegeven): niets meesturen, dan kan er ook
    // nooit onverwacht een meerprijs berekend worden
    if (!DATA.drukPrijzen || !Object.keys(DATA.drukPrijzen).length) return uit;
    state.positions.forEach(function (key) {
      var p = posInfo(key);
      if (!p) return;
      var klasse = (p.prijsklasse || 'klein').toLowerCase();
      if (klasse === 'klein' || klasse === 'groot') uit[klasse]++;
    });
    return uit;
  }
  /** variant-id van het toeslagproduct voor een prijsklasse */
  function drukVariantId(klasse) {
    return (DATA.drukVarianten || {})[klasse] || null;
  }
  /** totale bedrukkingsmeerprijs per stuk, in centen */
  function drukPerStuk() {
    if (!DATA.bedrukkingMogelijk) return 0;
    if (state.techniek === 'Geen bedrukking') return 0;
    var t = 0;
    state.positions.forEach(function (key) { t += drukPrijsVoor(key); });
    return t;
  }

  // Kleurnaam -> hex voor producten ZONDER bkp_kleur-metaobjects (kleur komt dan
  // uit de variantoptie). Zo krijgen ook die producten ronde kleur-swatches.
  // NL + EN namen (leveranciers als Tricorp/RTX gebruiken Engelse namen).
  var KLEUR_HEX = {
    'wit': '#FFFFFF', 'white': '#FFFFFF', 'off white': '#F4F1EA', 'ivoor': '#F1EBDD', 'ivory': '#F1EBDD', 'ecru': '#F1EBDD', 'natural': '#EDE4D3', 'creme': '#F2E8D5', 'cream': '#F2E8D5',
    'zwart': '#14181C', 'black': '#14181C', 'antraciet': '#3A3F45', 'anthracite': '#3A3F45', 'charcoal': '#3A3F45',
    'grijs': '#9AA0A6', 'grey': '#9AA0A6', 'gray': '#9AA0A6', 'sport grijs': '#9AA0A6', 'heather grey': '#B5B8BD', 'heather gray': '#B5B8BD', 'solid grey': '#8E9196', 'solid gray': '#8E9196', 'lichtgrijs': '#C9CCD1', 'light grey': '#C9CCD1', 'donkergrijs': '#55585E', 'dark grey': '#55585E', 'zilver': '#C4C7CC', 'silver': '#C4C7CC', 'steel grey': '#71767C',
    'navy': '#1B2A4A', 'donkerblauw': '#1B2A4A', 'marine': '#1B2A4A', 'midnight': '#16213E', 'blauw': '#2E5AAC', 'blue': '#2E5AAC', 'royal blue': '#2E5AAC', 'royal': '#2E5AAC', 'kobalt': '#1E4FD8', 'sapphire blue': '#1F4FA0', 'sapphire': '#1F4FA0', 'lichtblauw': '#7EB6E4', 'light blue': '#7EB6E4', 'sky blue': '#7EB6E4', 'sky': '#7EB6E4', 'sky blauw': '#7EB6E4', 'korenblauw': '#6495ED', 'cornflower blue': '#6495ED', 'aqua': '#3AC1CC', 'turquoise': '#2BB5C4', 'petrol': '#1F5F6B', 'teal': '#1F6F6B', 'denim': '#4A6B9A', 'azure': '#3D7EDB',
    'rood': '#C8102E', 'red': '#C8102E', 'bordeaux': '#6A1B2A', 'burgundy': '#6A1B2A', 'wijnrood': '#722F37', 'wine': '#722F37', 'donkerrood': '#8B0F23',
    'oranje': '#E8611A', 'orange': '#E8611A', 'coral': '#E86A5E', 'koraal': '#E86A5E',
    'geel': '#F4C400', 'yellow': '#F4C400', 'mosterd': '#D2A106', 'mustard': '#D2A106', 'goud': '#C9A227', 'gold': '#C9A227', 'sand': '#D9C49A', 'zand': '#D9C49A', 'beige': '#D9CBB3', 'khaki': '#B7A57A', 'stone': '#D6CFC4',
    'groen': '#2F7D3B', 'green': '#2F7D3B', 'bottle green': '#12463A', 'donkergroen': '#12463A', 'forest green': '#1F4D2E', 'kelly green': '#2FA05A', 'kelly groen': '#2FA05A', 'apple green': '#7DBB42', 'lime': '#A8D024', 'gif groen': '#A8D024', 'hi-vis groen': '#A8D024', 'hi vis green': '#A8D024', 'mint': '#9FD9C3', 'olijf': '#5B6236', 'olive': '#5B6236', 'army': '#5B6236', 'legergroen': '#5B6236',
    'paars': '#5B2D8E', 'purple': '#5B2D8E', 'plum': '#6C3462', 'lila': '#B69FD4', 'lavendel': '#B69FD4',
    'roze': '#E77FB1', 'pink': '#E77FB1', 'fuchsia': '#C7377D', 'framboos': '#C7377D', 'raspberry': '#C7377D', 'magenta': '#C2185B',
    'bruin': '#6B4A2F', 'brown': '#6B4A2F', 'chocolate': '#4E342E', 'chocolade': '#4E342E'
  };
  function hexVoorNaam(naam) {
    if (!naam) return null;
    return KLEUR_HEX[String(naam).toLowerCase().trim()] || null;
  }
  function swatchVoorNaam(naam) {
    var delen = String(naam || '').split('/').map(function (deel) { return deel.trim(); }).filter(Boolean);
    if (delen.length > 1) {
      var eerste = hexVoorNaam(delen[0]) || '#CCCCCC';
      var tweede = hexVoorNaam(delen[1]) || '#CCCCCC';
      return 'linear-gradient(135deg, ' + eerste + ' 0 50%, ' + tweede + ' 50% 100%)';
    }
    return hexVoorNaam(naam);
  }

  // ----- builders -----
  function buildSwatches() {
    var wrap = $('[data-swatches]'); wrap.innerHTML = '';
    if (heeftMetaKleuren) {
      DATA.kleuren.forEach(function (k, i) {
        var b = document.createElement('button');
        var variantNaam = k.variantNaam || k.naam;
        var swatch = String(variantNaam || '').indexOf('/') !== -1 ? swatchVoorNaam(variantNaam) : (k.hex || swatchVoorNaam(variantNaam));
        b.type = 'button'; b.title = k.naam;
        if (swatch) {
          b.className = 'bkp-wz__swatch';
          b.style.setProperty('--sw', swatch);
        } else {
          b.className = 'bkp-wz__swatch bkp-wz__swatch--text';
          b.textContent = k.naam;
        }
        b.setAttribute('aria-label', k.naam);
        b.setAttribute('aria-pressed', DATA.kleuren[i].naam === state.kleur.naam ? 'true' : 'false');
        b.addEventListener('click', function () { state.kleur = k; invalidateApproval(); exitGallery(); renderKleur(); saveState(); });
        wrap.appendChild(b);
      });
    } else if (simpeleKleuren.length) {
      // variantoptie-kleuren: ronde swatch als de naam een bekende kleur is,
      // anders een tekst-pill als terugval
      simpeleKleuren.forEach(function (naam) {
        var hex = hexVoorNaam(naam);
        var swatch = swatchVoorNaam(naam);
        var b = document.createElement('button');
        b.type = 'button'; b.title = naam;
        if (swatch) {
          b.className = 'bkp-wz__swatch';
          b.style.setProperty('--sw', swatch);
        } else {
          b.className = 'bkp-wz__swatch bkp-wz__swatch--text';
          b.textContent = naam;
        }
        b.setAttribute('aria-label', naam);
        b.setAttribute('aria-pressed', naam === state.kleur.naam ? 'true' : 'false');
        b.addEventListener('click', function () { state.kleur = { naam: naam, hex: hex }; invalidateApproval(); exitGallery(); renderKleur(); saveState(); });
        wrap.appendChild(b);
      });
    } else {
      // geen kleurkeuze: verberg stap 1 volledig
      var stap = wrap.closest('.bkp-wz__step');
      if (stap) stap.hidden = true;
    }
  }
  function buildSizes() {
    var wrap = $('[data-sizes]'); wrap.innerHTML = '';
    var maten = sizesForKleur(state.kleur.naam);
    // mobiel-grid: t/m 7 maten op 1 regel; daarboven gebalanceerd over 2 regels
    // (9 -> 5+4, 8 -> 4+4), cellen netjes onder elkaar uitgelijnd
    wrap.style.setProperty('--bkp-maat-cols', maten.length <= 7 ? Math.max(maten.length, 1) : Math.ceil(maten.length / 2));
    maten.forEach(function (v) {
      var cell = document.createElement('label');
      cell.className = 'bkp-wz__size' + (v.available ? '' : ' is-disabled');
      var span = document.createElement('span'); span.textContent = v.maat;
      var inp = document.createElement('input');
      inp.type = 'number'; inp.min = '0'; inp.inputMode = 'numeric'; inp.value = state.qty[v.maat] || '';
      inp.placeholder = '0'; inp.disabled = !v.available;
      inp.addEventListener('input', function () {
        var n = parseInt(inp.value, 10);
        var geclampt = isNaN(n) || n < 0 ? 0 : Math.min(n, 999);
        state.qty[v.maat] = geclampt;
        // veld meteen corrigeren zodat wat de klant ziet ook is wat er telt
        if (!isNaN(n) && (n > 999 || n < 0)) inp.value = String(geclampt);
        renderTotals(); saveState();
      });
      cell.appendChild(span); cell.appendChild(inp); wrap.appendChild(cell);
    });
  }
  function buildTech() {
    var wrap = $('[data-tech]'); wrap.innerHTML = '';
    // geen bedrukking mogelijk: bouw de keuze helemaal niet op, dan valt er ook
    // niets te kiezen als het blok onverhoopt toch zichtbaar zou worden
    if (!DATA.bedrukkingMogelijk) return;
    TECHS.forEach(function (t) {
      var id = 'tech-' + t.replace(/\s+/g, '-');
      var lab = document.createElement('label'); lab.className = 'bkp-wz__radio';
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.name = 'bkp-tech'; inp.value = t; inp.id = id;
      if (t === state.techniek) inp.checked = true;
      inp.addEventListener('change', function () { state.techniek = t; invalidateApproval(); renderTech(); saveState(); });
      lab.appendChild(inp); lab.appendChild(document.createTextNode(' ' + t));
      wrap.appendChild(lab);
    });
  }
  function buildPositions() {
    var wrap = $('[data-poslist]'); wrap.innerHTML = '';
    (DATA.posities || []).forEach(function (p) {
      var lab = document.createElement('label'); lab.className = 'bkp-wz__pos';
      var inp = document.createElement('input'); inp.type = 'checkbox'; inp.value = p.key;
      inp.checked = state.positions.indexOf(p.key) !== -1;
      inp.addEventListener('change', function () {
        if (inp.checked) {
          if (state.positions.indexOf(p.key) === -1) state.positions.push(p.key);
          if (!state.designs[p.key]) {
            var vorigeKey = state.positions.length > 1 ? state.positions[state.positions.length - 2] : null;
            state.designs[p.key] = defDesign(vorigeKey ? state.designs[vorigeKey] : null);
          }
        }
        else { state.positions = state.positions.filter(function (x) { return x !== p.key; }); }
        invalidateApproval(); renderDesigns(); renderPreview(); renderTotals(); saveState();
      });
      var txt = document.createElement('span');
      txt.innerHTML = p.naam + ' <small>(' + p.aanzicht + (p.maxcm ? ', max ' + p.maxcm + ' cm' : '') + ')</small>';
      lab.appendChild(inp); lab.appendChild(txt);
      // meerprijs per stuk zichtbaar bij de keuze zelf
      var prijs = drukPrijsVoor(p.key);
      if (prijs > 0) {
        var tag = document.createElement('em');
        tag.className = 'bkp-wz__posprijs';
        tag.textContent = '+' + euro(prijs) + ' p/st';
        lab.appendChild(tag);
      }
      wrap.appendChild(lab);
    });
  }
  // standaard zwart (witte tekst op een wit shirt is onzichtbaar); een nieuwe
  // positie erft de instellingen van het laatst gekozen ontwerp zodat kleur,
  // tekst en logo niet resetten bij het wisselen van positie
  function defDesign(basis) {
    var d = { type: 'tekst', text: '', font: DATA.fonts[0].css, color: '#14181C', logoUrl: null, logoFile: null, logoName: '', isVector: false, x: 50, y: 50, scale: 60 };
    if (basis) {
      d.type = basis.type; d.text = basis.text; d.font = basis.font; d.color = basis.color;
      d.logoUrl = basis.logoUrl; d.logoFile = basis.logoFile; d.logoName = basis.logoName; d.isVector = basis.isVector; d.scale = basis.scale;
    }
    return d;
  }

  function buildDesigns() {
    var wrap = $('[data-designs]'); wrap.innerHTML = '';
    var posByKey = {}; (DATA.posities || []).forEach(function (p) { posByKey[p.key] = p; });
    state.positions.forEach(function (key) {
      var p = posByKey[key]; if (!p) return;
      var d = state.designs[key] || (state.designs[key] = defDesign());
      var box = document.createElement('div'); box.className = 'bkp-wz__design-block';
      box.innerHTML =
        '<p class="bkp-wz__design-title">' + p.naam + '</p>' +
        '<div class="bkp-wz__seg2">' +
          '<button type="button" data-dtype="tekst" aria-pressed="' + (d.type === 'tekst' ? 'true' : 'false') + '" class="' + (d.type === 'tekst' ? 'is-active' : '') + '">Tekst</button>' +
          '<button type="button" data-dtype="logo" aria-pressed="' + (d.type === 'logo' ? 'true' : 'false') + '" class="' + (d.type === 'logo' ? 'is-active' : '') + '">Logo</button>' +
        '</div>' +
        '<div data-dtekst ' + (d.type === 'tekst' ? '' : 'hidden') + '>' +
          '<input type="text" data-dtext placeholder="Jouw tekst" value="' + (d.text || '').replace(/"/g, '&quot;') + '">' +
          '<div class="bkp-wz__row2">' +
            '<select data-dfont></select>' +
            '<input type="color" data-dcolor value="' + d.color + '" aria-label="Tekstkleur" title="Kies de tekstkleur">' +
          '</div>' +
        '</div>' +
        '<div data-dlogo ' + (d.type === 'logo' ? '' : 'hidden') + '>' +
          '<label class="bkp-drop" data-dropzone>' +
            '<input type="file" data-dfile accept="image/png,image/jpeg,image/svg+xml,application/pdf">' +
            '<span class="bkp-drop__icon"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4m0 0L7 9m5-5l5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg></span>' +
            '<span class="bkp-drop__title">Sleep je logo hierheen <em>of klik om te kiezen</em></span>' +
            '<span class="bkp-drop__sub">PNG, JPG, SVG of PDF &middot; max 10 MB</span>' +
          '</label>' +
          '<p class="bkp-wz__filehelp">Het originele bestand wordt veilig met je bestelling meegestuurd. Je ziet het logo direct in de voorbeeldweergave.</p>' +
          '<p class="bkp-wz__logoname" data-dlogoname>' + (d.logoName || '') + '</p>' +
          '<button type="button" class="bkp-wz__textaction" data-dremove ' + (d.logoName ? '' : 'hidden') + '>Verwijder bestand</button>' +
        '</div>' +
        '<label class="bkp-wz__scale">Grootte <input type="range" min="20" max="100" step="1" data-dscale value="' + d.scale + '"></label>' +
        '<div class="bkp-wz__design-actions"><button type="button" class="bkp-wz__textaction" data-dreset>Standaardgrootte</button></div>' +
        '<p class="bkp-wz__contrast" data-contrast hidden>Let op: deze tekstkleur heeft weinig contrast met de gekozen kledingkleur.</p>';
      wrap.appendChild(box);

      var fontSel = box.querySelector('[data-dfont]');
      DATA.fonts.forEach(function (f) { var o = document.createElement('option'); o.value = f.css; o.textContent = f.naam; if (f.css === d.font) o.selected = true; fontSel.appendChild(o); });

      box.querySelectorAll('[data-dtype]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          d.type = btn.getAttribute('data-dtype');
          box.querySelectorAll('[data-dtype]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          box.querySelector('[data-dtekst]').hidden = d.type !== 'tekst';
          box.querySelector('[data-dlogo]').hidden = d.type !== 'logo';
          invalidateApproval(); renderPreview(); renderTotals(); saveState();
        });
      });
      box.querySelector('[data-dtext]').addEventListener('input', function (e) { d.text = e.target.value; invalidateApproval(); renderPreview(); renderTotals(); saveState(); });
      fontSel.addEventListener('change', function (e) { d.font = e.target.value; invalidateApproval(); renderPreview(); renderTotals(); saveState(); });
      box.querySelector('[data-dcolor]').addEventListener('input', function (e) { d.color = e.target.value; invalidateApproval(); renderPreview(); renderContrast(box, d); renderTotals(); saveState(); });
      box.querySelector('[data-dscale]').addEventListener('input', function (e) { d.scale = parseInt(e.target.value, 10); invalidateApproval(); renderPreview(); renderTotals(); saveState(); });
      // drag & drop op de uploadzone: gedropt bestand door dezelfde change-flow leiden
      var dropzone = box.querySelector('[data-dropzone]');
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('is-drag'); });
      });
      dropzone.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        var inp = box.querySelector('[data-dfile]');
        try { inp.files = files; } catch (err) { return; }
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      box.querySelector('[data-dfile]').addEventListener('change', function (e) {
        var f = e.target.files[0]; if (!f) return;
        var allowed = ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf'];
        if (allowed.indexOf(f.type) === -1) { setFeedback('Dit bestandstype wordt niet ondersteund. Kies PNG, JPG, SVG of PDF.', true); e.target.value = ''; return; }
        if (f.size > 10 * 1024 * 1024) { setFeedback('Bestand te groot (max 10MB).', true); return; }
        d.logoFile = f;
        d.logoName = f.name;
        d.isVector = /\.(svg|pdf|ai|eps)$/i.test(f.name);
        var naamEl = box.querySelector('[data-dlogoname]');
        naamEl.classList.remove('is-warn', 'is-ok');
        if (d.isVector) {
          naamEl.textContent = f.name + ': vectorbestand, geen extra kosten';
          naamEl.classList.add('is-ok');
        } else {
          naamEl.textContent = f.name + ' is geen vectorbestand. Wij zetten het om naar drukklaar formaat: +' + euro(feePrijs('vectorisatie')) + ' eenmalig per ontwerp (zit in het totaal verwerkt).';
          naamEl.classList.add('is-warn');
        }
        box.querySelector('[data-dremove]').hidden = false;
        if (/^image\//.test(f.type)) { var r = new FileReader(); r.onload = function () { d.logoUrl = r.result; renderPreview(); }; r.readAsDataURL(f); }
        else { d.logoUrl = null; renderPreview(); }
        invalidateApproval(); renderTotals(); saveState();
      });
      box.querySelector('[data-dremove]').addEventListener('click', function () {
        d.logoUrl = null; d.logoFile = null; d.logoName = ''; d.isVector = false;
        box.querySelector('[data-dfile]').value = '';
        var naamLeeg = box.querySelector('[data-dlogoname]');
        naamLeeg.textContent = '';
        naamLeeg.classList.remove('is-warn', 'is-ok');
        box.querySelector('[data-dremove]').hidden = true;
        invalidateApproval(); renderPreview(); renderTotals(); saveState();
      });
      box.querySelector('[data-dreset]').addEventListener('click', function () { d.x = 50; d.y = 50; d.scale = 60; box.querySelector('[data-dscale]').value = 60; invalidateApproval(); renderPreview(); renderTotals(); saveState(); });
      renderContrast(box, d);
    });
    $('[data-design-step]').hidden = state.positions.length === 0;
    renumberSteps();
  }

  // ----- renderers -----
  // Foto per kleur: metaobject-foto (bkp_kleur.foto_voor) eerst, dan de
  // variant-afbeelding van die kleur (DATA.kleurFotos), anders de standaardfoto.
  function updateKleurFoto() {
    var photo = root.querySelector('[data-photo-view="voor"]');
    if (!photo) return;
    if (!photo.dataset.defaultSrc) photo.dataset.defaultSrc = photo.src;
    var variantKleur = variantKleurVoor(state.kleur.naam);
    var src = (state.kleur && state.kleur.voor) || (DATA.kleurFotos || {})[variantKleur] || photo.dataset.defaultSrc;
    if (photo.getAttribute('src') !== src) photo.src = src;
    var back = root.querySelector('[data-photo-view="achter"]');
    if (back) {
      if (!back.dataset.defaultSrc) back.dataset.defaultSrc = back.src;
      // achterkant per kleur: metaobject-foto > alt-gelabelde foto ("<kleur> achter") > standaard
      var bsrc = (state.kleur && state.kleur.achter) || (DATA.kleurFotosAchter || {})[variantKleur] || back.dataset.defaultSrc;
      if (back.getAttribute('src') !== bsrc) back.src = bsrc;
    }
  }
  function renderKleur() {
    $('[data-kleur-naam]').textContent = state.kleur.naam || '—';
    updateKleurFoto();
    root.querySelectorAll('[data-swatches] .bkp-wz__swatch').forEach(function (b) {
      var naam = b.title || b.textContent;
      b.classList.toggle('is-active', naam === state.kleur.naam);
      b.setAttribute('aria-pressed', naam === state.kleur.naam ? 'true' : 'false');
    });
    buildSizes();
    if (state.positions.length) buildDesigns();
    renderPreview(); renderTotals();
  }
  function renderTech() {
    var on = state.techniek !== 'Geen bedrukking';
    $('[data-positions]').hidden = !on;
    $('[data-approval-wrap]').hidden = !on;
    if (!on) { state.positions = []; buildPositions(); }
    renderDesigns(); renderPreview(); renderTotals();
  }
  function renderDesigns() { buildDesigns(); }
  function colorLuminance(hex) {
    var value = (hex || '').replace('#', ''); if (value.length === 3) value = value.split('').map(function (c) { return c + c; }).join('');
    var rgb = [0, 2, 4].map(function (i) { var c = parseInt(value.slice(i, i + 2), 16) / 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); });
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  }
  function contrastRatio(a, b) { var l1 = colorLuminance(a), l2 = colorLuminance(b); return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05); }
  function renderContrast(box, design) {
    var warning = box.querySelector('[data-contrast]'); if (!warning) return;
    if (!state.kleur.hex) { warning.hidden = true; return; }
    warning.hidden = design.type !== 'tekst' || contrastRatio(design.color, state.kleur.hex) >= 3;
  }
  // fotogalerij: extra productfoto's bekijken in de stage; terug naar de
  // ontwerp-weergave via de eerste thumb of de Voorkant/Achterkant-knoppen
  function exitGallery() {
    state.galleryUrl = null;
    root.querySelectorAll('[data-thumb]').forEach(function (t, i) { t.classList.toggle('is-active', i === 0); });
  }
  function bindThumbs() {
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        state.galleryUrl = i === 0 ? null : t.getAttribute('data-thumb');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        renderPreview();
      });
    });
    // pijltjes op de foto: bladeren door dezelfde lijst als de thumbnails
    // (index 0 = ontwerp-weergave); rondlopen aan beide kanten
    function stap(richting) {
      var lijst = root.querySelectorAll('[data-thumb]');
      if (!lijst.length) return;
      var idx = 0;
      lijst.forEach(function (x, j) { if (x.classList.contains('is-active')) idx = j; });
      var volgende = (idx + richting + lijst.length) % lijst.length;
      lijst[volgende].click();
      if (lijst[volgende].scrollIntoView) lijst[volgende].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    var prev = root.querySelector('[data-stage-prev]');
    var next = root.querySelector('[data-stage-next]');
    if (prev) prev.addEventListener('click', function () { stap(-1); });
    if (next) next.addEventListener('click', function () { stap(1); });
  }
  function setView(v) {
    state.view = v;
    exitGallery();
    root.querySelectorAll('[data-view-btn]').forEach(function (b) {
      var active = b.getAttribute('data-view-btn') === v;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    renderPreview(); saveState();
  }
  function renderPreview() {
    var fillEl = root.querySelector('[data-garment-fill]');
    if (state.kleur.hex && fillEl) fillEl.setAttribute('fill', state.kleur.hex);
    // galerij-foto boven alles als die actief is
    var galleryImg = root.querySelector('[data-photo-gallery]');
    if (galleryImg) {
      if (state.galleryUrl && galleryImg.getAttribute('src') !== state.galleryUrl) galleryImg.src = state.galleryUrl;
      galleryImg.hidden = !state.galleryUrl;
    }
    // Voor/achter-foto wisselen op aanzicht (1e afbeelding = voor, 2e = achter).
    // Zonder achter-foto blijft de voor-foto zichtbaar (indicatief).
    var backPhoto = root.querySelector('[data-photo-view="achter"]');
    root.querySelectorAll('[data-photo-view]').forEach(function (img) {
      var v = img.getAttribute('data-photo-view');
      img.hidden = Boolean(state.galleryUrl) || (backPhoto ? v !== state.view : v !== 'voor');
    });
    // melding als de getoonde foto niet bij de gekozen kleur hoort (ter illustratie):
    // de klant ziet bv. een navy achterkant terwijl hij wit bestelt
    var colorNote = root.querySelector('[data-color-note]');
    if (colorNote) {
      var toonNote = false;
      if (!state.galleryUrl && DATA.fotoModus && kleurDimensie && state.kleur.naam) {
        var specifiek;
        var variantKleur = variantKleurVoor(state.kleur.naam);
        if (state.view === 'achter' && root.querySelector('[data-photo-view="achter"]')) {
          specifiek = Boolean((state.kleur && state.kleur.achter) || (DATA.kleurFotosAchter || {})[variantKleur]);
        } else {
          specifiek = Boolean((state.kleur && state.kleur.voor) || (DATA.kleurFotos || {})[variantKleur]);
        }
        toonNote = !specifiek;
      }
      colorNote.hidden = !toonNote;
      if (toonNote) colorNote.textContent = 'Foto ter illustratie — je ontvangt dit product in je gekozen kleur (' + state.kleur.naam + ').';
    }
    var anyOnView = false;
    root.querySelectorAll('[data-print]').forEach(function (pa) {
      var key = pa.getAttribute('data-print');
      var show = !state.galleryUrl && state.positions.indexOf(key) !== -1 && pa.getAttribute('data-view') === state.view && state.techniek !== 'Geen bedrukking';
      pa.hidden = !show;
      if (show) { anyOnView = true; paintDesign(pa, key); }
    });
    var hint = root.querySelector('[data-preview-hint]');
    if (state.galleryUrl) hint.textContent = 'Productfoto. Klik de eerste thumbnail of Voorkant om verder te ontwerpen.';
    else if (!DATA.bedrukkingMogelijk) hint.textContent = 'Dit product bestel je zoals afgebeeld.';
    else if (state.techniek === 'Geen bedrukking') hint.textContent = 'Geen bedrukking gekozen. Je bestelt het blanco kledingstuk.';
    else if (state.positions.length === 0) hint.textContent = 'Kies een positie in stap 3 om je logo of tekst te plaatsen.';
    else if (!anyOnView) hint.textContent = 'Wissel van aanzicht om je ontwerp op de andere kant te zien.';
    else hint.textContent = 'Je ontwerp staat gecentreerd in het printvlak; de grootte pas je aan in stap 4.';
  }
  function paintDesign(pa, key) {
    var d = state.designs[key]; var el = pa.querySelector('[data-design]'); if (!d) { el.innerHTML = ''; return; }
    // vaste positie: altijd gecentreerd (oude opgeslagen x/y worden genegeerd)
    el.style.left = '50%'; el.style.top = '50%'; el.style.width = d.scale + '%';
    if (d.type === 'tekst') {
      el.innerHTML = '<span style="font-family:' + d.font + '; color:' + d.color + '">' + (d.text ? escapeHtml(d.text) : 'Jouw tekst') + '</span>';
      el.classList.toggle('is-empty', !d.text);
    } else if (d.logoUrl) {
      el.innerHTML = '<img src="' + d.logoUrl + '" alt="">'; el.classList.remove('is-empty');
    } else {
      el.innerHTML = '<span class="bkp-wz__ph">' + (d.logoName ? 'Bestand geselecteerd' : 'Upload je logo') + '</span>';
      el.classList.toggle('is-empty', !d.logoName);
    }
  }
  function escapeHtml(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function feePrijs(k) { return (DATA.fees && DATA.fees[k] && DATA.fees[k].prijs) || 0; }
  function feeId(k) { return DATA.fees && DATA.fees[k] && DATA.fees[k].id; }
  function countNonVectorLogos() {
    // UNIEKE logo-bestanden tellen, niet posities: hetzelfde logo op borst én rug
    // is één keer vectoriseren ("eenmalig per ontwerp" zoals de upload belooft)
    if (state.techniek === 'Geen bedrukking') return 0;
    var namen = [];
    state.positions.forEach(function (key) {
      var d = state.designs[key];
      if (d && d.type === 'logo' && d.logoName && !d.isVector && namen.indexOf(d.logoName) === -1) namen.push(d.logoName);
    });
    return namen.length;
  }
  function renderBreakdown(tot, drukTot, vectCount, vectTot, spoedTot) {
    var el = $('[data-breakdown]'); if (!el) return;
    var rows = [];
    if (drukTot > 0) {
      var n = state.positions.filter(function (k) { return drukPrijsVoor(k) > 0; }).length;
      rows.push('<span>Bedrukking (' + n + (n === 1 ? ' positie' : ' posities') + ')</span><span>+' + euro(drukTot) + '</span>');
    }
    if (vectCount > 0) rows.push('<span>Vectorisatie (' + vectCount + '&times; logo op maat)</span><span>+' + euro(vectTot) + '</span>');
    if (spoedTot > 0) rows.push('<span>Spoedlevering 48 uur</span><span>+' + euro(spoedTot) + '</span>');
    if (rows.length) {
      rows.unshift('<span>Kleding</span><span>' + euro(tot) + '</span>');
      el.innerHTML = rows.map(function (r) { return '<div class="bkp-wz__brline">' + r + '</div>'; }).join('');
      el.hidden = false;
    } else { el.hidden = true; el.innerHTML = ''; }
  }
  function renderTotals() {
    var q = totalQty(), unit = unitCents();
    // all-in stukprijs: kledingstuk + bedrukking. De klant rekent hier straks op af,
    // dus de balk moet dit tonen en niet alleen de kledingprijs.
    var druk = drukPerStuk();
    var alles = unit + druk;
    var tot = q * unit, drukTot = q * druk;
    // toeslagen alleen meetellen als er iets besteld wordt (anders "0 stuks — €65")
    var vectCount = q > 0 ? countNonVectorLogos() : 0;
    var vectTot = vectCount * feePrijs('vectorisatie');
    var spoedTot = q > 0 && state.spoed ? feePrijs('spoed') : 0;
    var grand = tot + drukTot + vectTot + spoedTot;
    $('[data-totlabel]').textContent = q + (q === 1 ? ' stuk' : ' stuks') + (q ? ' × ' + euro(alles) : '');
    $('[data-totprice]').textContent = euro(grand);
    renderBreakdown(tot, drukTot, vectCount, vectTot, spoedTot);
    // staffeltabel
    var tbl = $('[data-tiers]'), tb = tbl.querySelector('tbody'); tb.innerHTML = '';
    var act = activeTier();
    (DATA.staffels || []).forEach(function (t) {
      var tr = document.createElement('tr'); if (t === act) tr.setAttribute('data-active', 'true');
      var per = Math.round(DATA.base * (1 - (t.korting_pct || 0) / 100));
      tr.innerHTML = '<td>' + t.min + '+</td><td>' + euro(per) + '</td><td>' + (t.korting_pct ? '<span class="bkp-tier-badge">−' + t.korting_pct + '%</span>' : '<span class="bkp-tier-dash">—</span>') + '</td>';
      tb.appendChild(tr);
    });
    tbl.hidden = (DATA.staffels || []).length === 0;
    // min afname: geldt over de hele bestelling, dus inclusief de winkelwagen
    var totaal = bestelQty();
    var tekort = DATA.minAfname - totaal;
    var wagenErbij = winkelwagenQty > 0 ? ' (' + totaal + ' met je winkelwagen erbij)' : '';
    var note = $('[data-minnote]');
    note.classList.remove('is-warn', 'is-ok');
    if (q === 0 && perStuk) {
      note.textContent = 'Dit artikel bestel je al vanaf 1 stuk.';
    } else if (q === 0) {
      note.textContent = winkelwagenQty > 0
        ? 'Je hebt al ' + winkelwagenQty + ' stuks in je winkelwagen. Je bestelt vanaf ' + DATA.minAfname + ' stuks per bestelling; mixen mag.'
        : 'Je bestelt vanaf ' + DATA.minAfname + ' stuks per bestelling. Mixen mag: verdeel ze vrij over maten en producten.';
    } else if (!perStuk && tekort > 0) {
      // onder de minimale afname: opvallende melding, anders lijkt de knop kapot
      note.textContent = 'Je hebt er ' + q + ' gekozen' + wagenErbij + '. Kies er nog ' + tekort +
        ' bij: bestellen kan vanaf ' + DATA.minAfname + ' stuks per bestelling. Mixen met een ander product mag ook.';
      note.classList.add('is-warn');
    } else {
      var next = (DATA.staffels || []).filter(function (t) { return t.min > q; })[0];
      if (next) note.textContent = 'Nog ' + (next.min - q) + ' stuks tot ' + next.korting_pct + '% korting.';
      else if ((DATA.staffels || []).length) note.textContent = 'Beste staffelprijs bereikt.';
      else note.textContent = perStuk ? 'Dit artikel bestel je al vanaf 1 stuk.' : 'Je aantal voldoet aan de minimale afname.';
      note.classList.add('is-ok');
    }
    // max afname: boven 50 stuks in de bestelling geen directe bestelling maar offerte op maat
    // drempel toetsen op artikelen met dezelfde drempel, niet op de hele bestelling
    var drempelTotaal = drempelQty();
    var overMax = maxAfname > 0 && drempelTotaal > maxAfname;
    var offNote = $('[data-offerte-note]');
    var offBtn = $('[data-offerte-btn]');
    offNote.hidden = !overMax;
    offNote.classList.toggle('is-offerte', overMax);
    if (overMax) {
      // tekst in één span: het blok is display:flex (icoon + tekst), losse tekstnodes zouden anders elk een flex-item worden
      offNote.innerHTML = '<span>Je komt op <strong>' + drempelTotaal + ' stuks</strong>' +
        (winkelwagenQtyZelfdeDrempel > 0 ? ' inclusief je winkelwagen' : '') + '. Bij meer dan ' + maxAfname +
        ' stuks maken we een scherp tarief op maat. Vraag een vrijblijvende offerte aan.</span>';
    }
    // knop wisselen: In winkelwagen ↔ Vraag offerte aan; balk verbergt de (misleidende) prijs
    $('[data-add]').hidden = overMax;
    if (offBtn) offBtn.hidden = !overMax;
    $('[data-bar]').classList.toggle('is-offerte', overMax);
    // add-knop
    renderSummary();
    var designsComplete = state.techniek === 'Geen bedrukking' || state.positions.every(function (key) {
      var d = state.designs[key]; return d && (d.type === 'tekst' ? Boolean((d.text || '').trim()) : Boolean(d.logoFile));
    });
    var proofReady = state.techniek === 'Geen bedrukking' || state.proofApproved;
    // Toevoegen mag ook onder het minimum: de klant mag aanvullen met een ander
    // product. Winkelwagen en checkout bewaken de totale bestelling.
    var ok = q > 0 && !overMax && (state.techniek === 'Geen bedrukking' || state.positions.length > 0) && designsComplete && proofReady;
    $('[data-add]').disabled = !ok;
  }
  function renderSummary() {
    var el = $('[data-summary]'); if (!el) return;
    var q = totalQty();
    var sizes = Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; }).map(function (k) { return k + ': ' + state.qty[k]; }).join(', ');
    var posByKey = {}; (DATA.posities || []).forEach(function (p) { posByKey[p.key] = p.naam; });
    var positions = state.positions.map(function (key) { return posByKey[key] || key; }).join(', ');
    el.innerHTML = '<dl>' +
      '<div><dt>Kleur</dt><dd>' + escapeHtml(state.kleur.naam || '—') + '</dd></div>' +
      '<div><dt>Maten</dt><dd>' + escapeHtml(sizes || 'Nog niet ingevuld') + '</dd></div>' +
      '<div><dt>Aantal</dt><dd>' + q + ' stuks</dd></div>' +
      '<div><dt>Uitvoering</dt><dd>' + escapeHtml(state.techniek) + (positions ? ': ' + escapeHtml(positions) : '') + '</dd></div>' +
      '</dl>';
  }
  function setFeedback(msg, err) { var f = $('[data-feedback]'); f.textContent = msg; f.className = 'bkp-wz__feedback' + (err ? ' is-error' : ' is-ok'); }

  // Geen vrij slepen/verschuiven in de preview: het ontwerp staat VAST gecentreerd
  // in het gekozen printvlak. Alleen de grootte is instelbaar (slider in stap 4).
  // De exacte plaatsing wordt altijd bevestigd in de digitale drukproef.

  // ----- add to cart -----
  // Shopify kan echte bestanden als line-item property opslaan wanneer /cart/add
  // multipart FormData ontvangt. We zetten alle unieke logo's op de eerste
  // kledingregel; de gedeelde ontwerp-id koppelt de overige maten en toeslagen.
  function logoUploads() {
    var posByKey = {};
    (DATA.posities || []).forEach(function (p) { posByKey[p.key] = p.naam; });
    var groups = {};
    state.positions.forEach(function (key) {
      var d = state.designs[key];
      if (!d || d.type !== 'logo' || !d.logoFile) return;
      var f = d.logoFile;
      var sig = [f.name, f.size, f.lastModified, f.type].join('|');
      if (!groups[sig]) groups[sig] = { file: f, positions: [] };
      groups[sig].positions.push(posByKey[key] || key);
    });
    return Object.keys(groups).map(function (sig, i) {
      var g = groups[sig];
      return {
        label: 'Logo-bestand ' + (i + 1) + ' (' + g.positions.join(', ') + ')',
        file: g.file
      };
    });
  }
  function loadProofImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Afbeelding kon niet in de drukproef worden geladen.')); };
      img.src = src;
    });
  }
  function drawContained(ctx, img, x, y, width, height) {
    var ratio = Math.min(width / img.naturalWidth, height / img.naturalHeight);
    var w = img.naturalWidth * ratio, h = img.naturalHeight * ratio;
    ctx.drawImage(img, x + (width - w) / 2, y + (height - h) / 2, w, h);
  }
  function canvasFile(canvas, name) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) { reject(new Error('Drukproef kon niet worden opgeslagen.')); return; }
        resolve(new File([blob], name, { type: 'image/png' }));
      }, 'image/png');
    });
  }
  function proofBaseSource(view) {
    var photo = root.querySelector('[data-photo-view="' + view + '"]') || root.querySelector('[data-photo-view="voor"]');
    if (photo && (photo.currentSrc || photo.src)) return photo.currentSrc || photo.src;
    var garment = root.querySelector('[data-garment]');
    if (!garment) return null;
    var svg = new XMLSerializer().serializeToString(garment);
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  function createProofForView(view, positions) {
    var size = 1200;
    var canvas = document.createElement('canvas');
    canvas.width = size; canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, size, size);

    // Exact dezelfde 400:460-ontwerpcanvas en 94%-hoogte als de zichtbare wizard.
    var innerH = size * 0.94;
    var innerW = innerH * 400 / 460;
    var innerX = (size - innerW) / 2;
    var innerY = (size - innerH) / 2;
    var baseSource = proofBaseSource(view);
    if (!baseSource) return Promise.reject(new Error('Productafbeelding ontbreekt.'));

    return loadProofImage(baseSource).then(function (base) {
      var pad = innerH * 0.03;
      drawContained(ctx, base, innerX + pad, innerY + pad, innerW - pad * 2, innerH - pad * 2);
      return Promise.all(positions.map(function (item) {
        var d = state.designs[item.key] || {};
        return d.type === 'logo' && d.logoUrl ? loadProofImage(d.logoUrl) : Promise.resolve(null);
      }));
    }).then(function (designImages) {
      positions.forEach(function (item, index) {
        var d = state.designs[item.key] || {};
        var print = Array.prototype.filter.call(root.querySelectorAll('[data-print]'), function (node) {
          return node.getAttribute('data-print') === item.key;
        })[0];
        if (!print) return;
        var x = innerX + innerW * parseFloat(print.style.left || 0) / 100;
        var y = innerY + innerH * parseFloat(print.style.top || 0) / 100;
        var w = innerW * parseFloat(print.style.width || 0) / 100;
        var h = innerH * parseFloat(print.style.height || 0) / 100;
        ctx.save();
        ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
        var designW = w * (d.scale || 60) / 100;
        if (d.type === 'tekst') {
          var fontSize = Math.max(13, designW * 0.25);
          ctx.fillStyle = d.color || '#14181c';
          ctx.font = '700 ' + fontSize + 'px ' + (d.font || 'Arial, sans-serif');
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(d.text || 'Jouw tekst', x + w / 2, y + h / 2, Math.max(1, w * 0.94));
        } else if (designImages[index]) {
          var logo = designImages[index];
          var designH = designW * logo.naturalHeight / logo.naturalWidth;
          ctx.drawImage(logo, x + (w - designW) / 2, y + (h - designH) / 2, designW, designH);
        } else {
          ctx.fillStyle = '#e8eefb'; ctx.fillRect(x + w * 0.12, y + h * 0.36, w * 0.76, h * 0.28);
          ctx.fillStyle = '#526079'; ctx.font = '600 ' + Math.max(12, w * 0.08) + 'px Arial, sans-serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText('Logo-bestand geselecteerd', x + w / 2, y + h / 2, w * 0.7);
        }
        ctx.restore();
        ctx.save();
        ctx.strokeStyle = 'rgba(15, 27, 61, 0.72)'; ctx.lineWidth = 3; ctx.setLineDash([10, 7]);
        ctx.strokeRect(x, y, w, h); ctx.restore();
      });
      var label = view === 'achter' ? 'Achterkant' : 'Voorkant';
      return canvasFile(canvas, 'akkoord-preview-' + state.designId + '-' + view + '.png').then(function (file) {
        return { label: 'Akkoord-preview (' + label + ')', file: file };
      });
    });
  }
  function proofUploads() {
    if (state.techniek === 'Geen bedrukking' || !state.positions.length) return Promise.resolve([]);
    var posByView = {};
    var posByKey = {}; (DATA.posities || []).forEach(function (p) { posByKey[p.key] = p; });
    state.positions.forEach(function (key) {
      var p = posByKey[key]; if (!p) return;
      var view = p.aanzicht === 'achter' ? 'achter' : 'voor';
      if (!posByView[view]) posByView[view] = [];
      posByView[view].push({ key: key, position: p });
    });
    return Promise.all(Object.keys(posByView).map(function (view) {
      return createProofForView(view, posByView[view]);
    }));
  }
  function cartUrl(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + path.replace(/^\//, '');
  }
  function responseWithBody(r) {
    return r.json().then(function (b) { return { ok: r.ok, b: b }; });
  }
  function addJson(items) {
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
    }).then(responseWithBody);
  }
  function addCarrierWithUploads(carrier, uploads) {
    var body = new FormData();
    body.append('id', carrier.id);
    body.append('quantity', carrier.quantity);
    var keys = Object.keys(carrier.properties || {});
    keys.filter(function (key) { return key.charAt(0) !== '_'; }).forEach(function (key) {
      body.append('properties[' + key + ']', carrier.properties[key]);
    });
    uploads.forEach(function (upload) {
      body.append('properties[' + upload.label + ']', upload.file, upload.file.name);
    });
    keys.filter(function (key) { return key.charAt(0) === '_'; }).forEach(function (key) {
      body.append('properties[' + key + ']', carrier.properties[key]);
    });
    return fetch(cartUrl('cart/add.js'), { method: 'POST', body: body }).then(responseWithBody);
  }
  function removeCarrier(key) {
    if (!key) return Promise.resolve();
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(function () { /* een half toegevoegde regel is zichtbaar en handmatig te verwijderen */ });
  }
  function addToCart() {
    if (maxAfname > 0 && drempelQty() > maxAfname) {
      setFeedback('Bij meer dan ' + maxAfname + ' stuks vragen we voor dit soort artikelen een offerte op maat.', true);
      return;
    }
    // product zonder bedrukkingsmogelijkheid: forceer een blanco bestelling, ook als
    // de keuze via de DOM tóch bereikbaar was
    if (!DATA.bedrukkingMogelijk) {
      state.techniek = 'Geen bedrukking';
      state.positions = [];
    }
    // niet alleen op de disabled-knop vertrouwen: hercontroleer ontwerp + akkoord
    if (state.techniek !== 'Geen bedrukking') {
      var compleet = state.positions.length > 0 && state.positions.every(function (key) {
        var d = state.designs[key]; return d && (d.type === 'tekst' ? Boolean((d.text || '').trim()) : Boolean(d.logoFile));
      });
      if (!compleet) { setFeedback('Maak eerst je ontwerp af (stap 3 en 4).', true); return; }
      if (!state.proofApproved) { setFeedback('Vink eerst het akkoord over de digitale drukproef aan.', true); return; }
    }
    var items = [];
    sizesForKleur(state.kleur.naam).forEach(function (v) {
      var q = state.qty[v.maat] || 0; if (q <= 0) return;
      var id = variantId(state.kleur.naam, v.maat); if (!id) return;
      items.push({ id: id, quantity: q, properties: buildProps() });
    });
    if (!items.length) { setFeedback('Vul minstens één aantal in.', true); return; }
    // Bedrukking als aparte regels, aantal = stuks x posities in die klasse.
    // (Cart Transform zou dit netter in de kledingregel doen, maar dat vereist
    // Shopify Plus. bkp-ui.js houdt deze aantallen synchroon met de kleding en
    // de checkout-validatie blokkeert als het toch uit de pas loopt.)
    var dr2 = drukAantallen(), qTot = totalQty();
    ['klein', 'groot'].forEach(function (klasse) {
      var n = dr2[klasse];
      if (!n) return;
      var vid = drukVariantId(klasse);
      if (!vid) return;
      items.push({
        id: vid,
        quantity: n * qTot,
        properties: {
          '_bkp_ref': state.designId,
          '_bkp_klasse': klasse,
          'Berekening': n + (n === 1 ? ' positie' : ' posities') + ' × ' + qTot + ' kledingstukken'
        }
      });
    });
    // overige toeslagen
    var vectCount = countNonVectorLogos();
    if (vectCount > 0 && feeId('vectorisatie')) items.push({ id: feeId('vectorisatie'), quantity: vectCount, properties: { '_bkp_ref': state.designId } });
    // spoed is EENMALIG per bestelling: nooit een tweede regel toevoegen; ref is
    // 'bestelling' (niet het designId) zodat hij geldig blijft zolang er kleding is
    if (state.spoed && feeId('spoed') && !spoedInCart) items.push({ id: feeId('spoed'), quantity: 1, properties: { '_bkp_ref': 'bestelling' } });
    $('[data-add]').disabled = true;
    var originalUploads = logoUploads();
    setFeedback(state.techniek !== 'Geen bedrukking' ? 'Drukproef en bestanden opslaan…' : 'Toevoegen…', false);
    proofUploads().then(function (previews) {
      var uploads = originalUploads.concat(previews);
      if (uploads.length) {
        var carrier = items.shift();
        return addCarrierWithUploads(carrier, uploads).then(function (carrierRes) {
          if (!carrierRes.ok) return carrierRes;
          if (!items.length) return carrierRes;
          return addJson(items).then(function (restRes) {
            if (restRes.ok) return restRes;
            return removeCarrier(carrierRes.b && carrierRes.b.key).then(function () { return restRes; });
          });
        });
      }
      return addJson(items);
    })
      .then(function (res) {
        if (!res.ok) { setFeedback(res.b.description || 'Toevoegen mislukt.', true); $('[data-add]').disabled = false; return; }
        setFeedback('Toegevoegd aan winkelwagen!', false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // Nieuw ontwerp-id + aantallen leeg VOOR de redirect: bij terugkeren mag
        // nogmaals klikken nooit dezelfde regels/toeslagen laten mergen (dubbele
        // toeslag!), en het oude id zou de winkelwagen-teller laten misrekenen.
        state.designId = 'bkp-' + Date.now().toString(36);
        state.qty = {};
        state.proofApproved = false;
        saveState();
        window.location.href = '/cart';
      })
      .catch(function (error) {
        setFeedback((error && error.message) || 'Er ging iets mis. Probeer opnieuw.', true);
        $('[data-add]').disabled = false;
      });
  }
  function buildProps() {
    // Leesbare productie-informatie eerst: Shopify Admin bewaart de volgorde van
    // line-item properties, waardoor de eigenaar niet door techniekvelden hoeft.
    var props = { 'Uitvoering': state.techniek };
    if (state.techniek !== 'Geen bedrukking' && state.positions.length) {
      var posByKey = {}; (DATA.posities || []).forEach(function (p) { posByKey[p.key] = p; });
      state.positions.forEach(function (key, i) {
        var p = posByKey[key], d = state.designs[key]; if (!p || !d) return;
        props['Positie ' + (i + 1)] = p.naam;
        props['Ontwerp ' + (i + 1)] = d.type === 'tekst' ? ('Tekst — "' + (d.text || '') + '"') : ('Logo — ' + (d.logoName || 'bestand volgt'));
        props['Grootte ' + (i + 1)] = (d.scale || 60) + '% van het printvlak';
        props['Plaatsing ' + (i + 1)] = 'Gecentreerd';
      });
      props['Drukproef akkoord'] = state.proofApproved ? 'Ja, goedgekeurd door klant' : 'Nee';
    }

    // _bkp_min / _bkp_max reizen mee naar winkelwagen en checkout-Function: die
    // kennen de wizard-preset per producttype niet, alleen de product-metafields.
    props['_bkp_design_id'] = state.designId;
    props['_bkp_min'] = String(DATA.minAfname);
    props['_bkp_max'] = String(maxAfname);
    // aantal bedrukte posities per prijsklasse: hierop rekent de cart-transform-
    // functie de meerprijs, die zo automatisch meeschaalt met het aantal stuks
    var dr = drukAantallen();
    props['_bkp_druk_klein'] = String(dr.klein);
    props['_bkp_druk_groot'] = String(dr.groot);
    // compacte telling van te vectoriseren logo's: overleeft het uitklappen van
    // de regel (waar de volledige _bkp_design-JSON niet mee kan) zodat de
    // checkout-controle op de vectorisatie-toeslag blijft werken
    props['_bkp_vect'] = String(countNonVectorLogos());
    return props;
  }

  function initExtras() {
    var wrap = $('[data-spoed-wrap]');
    if (DATA.opVoorraad && wrap) {
      wrap.hidden = false;
      var cb = $('[data-spoed]');
      cb.checked = Boolean(state.spoed); // herstelde sessie: vinkje syncen met de state
      cb.addEventListener('change', function () { state.spoed = cb.checked; renderTotals(); saveState(); });
    } else {
      state.spoed = false; // geen spoed-optie zichtbaar: nooit stil een toeslag rekenen
    }
  }

  // zichtbare stappen hernummeren (stap 1 kan verborgen zijn bij producten zonder kleurkeuze)
  function renumberSteps() {
    var n = 1;
    root.querySelectorAll('.bkp-wz__step').forEach(function (sec) {
      if (sec.hidden) return;
      var num = sec.querySelector('.bkp-wz__num');
      if (num) num.textContent = n++;
    });
  }

  function initMaattabel() {
    var dlg = document.querySelector('[data-maattabel-dialog]');
    if (!dlg) return;
    // document-breed: ook de maattabel-link in de product-info accordeon opent de popup
    document.querySelectorAll('[data-maattabel-open]').forEach(function (open) {
      open.addEventListener('click', function () { dlg.showModal(); });
    });
    dlg.querySelector('[data-maattabel-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  function initImageZoom() {
    var open = root.querySelector('[data-image-zoom-open]');
    var dlg = document.querySelector('[data-image-zoom-dialog]');
    if (!open || !dlg) return;

    var close = dlg.querySelector('[data-image-zoom-close]');
    var surface = dlg.querySelector('[data-image-zoom-toggle]');
    var zoomImage = dlg.querySelector('[data-image-zoom-image]');
    var scrollLockWasPresent = false;

    function largeImageUrl(src) {
      try {
        var url = new URL(src, window.location.href);
        if (/cdn\.shopify\.com$/i.test(url.hostname)) url.searchParams.set('width', '2400');
        return url.href;
      } catch (e) {
        return src;
      }
    }

    function currentPhoto() {
      return Array.prototype.filter.call(root.querySelectorAll('.bkp-wz__photo'), function (img) {
        return !img.hidden;
      })[0];
    }

    open.addEventListener('click', function () {
      var photo = currentPhoto();
      if (!photo || !photo.src) return;
      surface.classList.remove('is-actual-size');
      surface.setAttribute('aria-pressed', 'false');
      surface.setAttribute('aria-label', 'Afbeelding op ware grootte bekijken');
      zoomImage.alt = photo.alt || 'Vergrote productafbeelding';
      zoomImage.src = largeImageUrl(photo.currentSrc || photo.src);
      scrollLockWasPresent = document.documentElement.hasAttribute('scroll-lock');
      dlg.showModal();
      document.documentElement.setAttribute('scroll-lock', '');
    });

    close.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (event) {
      if (event.target === dlg || event.target.classList.contains('bkp-product-zoom__viewport')) dlg.close();
    });
    dlg.addEventListener('close', function () {
      surface.classList.remove('is-actual-size');
      surface.setAttribute('aria-pressed', 'false');
      zoomImage.removeAttribute('src');
      if (!scrollLockWasPresent) document.documentElement.removeAttribute('scroll-lock');
    });
    surface.addEventListener('click', function () {
      var actual = surface.classList.toggle('is-actual-size');
      surface.setAttribute('aria-pressed', String(actual));
      surface.setAttribute('aria-label', actual ? 'Afbeelding passend in beeld bekijken' : 'Afbeelding op ware grootte bekijken');
    });
  }

  // ----- init -----
  buildSwatches(); buildTech(); buildPositions(); initExtras(); initMaattabel(); initImageZoom(); bindThumbs();
  root.querySelectorAll('[data-view-btn]').forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-view-btn')); }); });
  $('[data-add]').addEventListener('click', addToCart);
  $('[data-proof-approval]').checked = Boolean(state.proofApproved);
  $('[data-proof-approval]').addEventListener('change', function (e) { state.proofApproved = e.target.checked; renderTotals(); saveState(); });
  $('[data-reset]').addEventListener('click', function () { sessionStorage.removeItem(STORAGE_KEY); window.location.reload(); });
  if (!DATA.bedrukkingMogelijk) {
    // geen bedrukking: techniek-stap toont alleen de melding, ontwerp/akkoord niet nodig
    var appr = $('[data-approval-wrap]'); if (appr) appr.hidden = true;
  }
  // Verberg de Voor/Achter-toggle als er geen achterkant is om naar te wisselen:
  // geen achter-posities EN geen achter-foto. Voorkomt een dead-end/overbodige knop.
  var hasBack = (DATA.posities || []).some(function (p) { return p.aanzicht === 'achter'; });
  var hasBackPhoto = Boolean(root.querySelector('[data-photo-view="achter"]'));
  if (!hasBack && !hasBackPhoto) {
    var views = root.querySelector('.bkp-wz__views'); if (views) views.hidden = true;
  }
  renderKleur(); renderTech();
  // herstelde sessie: Voor/Achterkant-knoppen syncen met de opgeslagen weergave
  // (knoppen stonden anders altijd op 'Voorkant' terwijl de preview 'achter' toonde)
  if (hasBack || hasBackPhoto) setView(state.view === 'achter' ? 'achter' : 'voor');
  else state.view = 'voor';
  laadWinkelwagen(); // minimum geldt over de hele bestelling: tel de winkelwagen mee
  // winkelwagen kan wijzigen terwijl deze pagina open staat (drawer) of via de
  // terug-knop (bfcache): teller en velden dan opnieuw syncen
  document.addEventListener('cart:refresh', laadWinkelwagen);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    laadWinkelwagen();
    buildSizes();
    $('[data-proof-approval]').checked = Boolean(state.proofApproved);
    renderTotals();
  });
  renumberSteps();
})();
